import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {AngularFireUploadTask} from '@angular/fire/compat/storage';
import {FileManagerService, StoredFile} from './file-manager.service';
import {MatTableDataSource} from '@angular/material/table';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {MatDialog} from '@angular/material/dialog';
import {Clipboard} from '@angular/cdk/clipboard';

@Component({
  selector: 'app-file-manager',
  templateUrl: './file-manager.component.html',
  styleUrls: [ './file-manager.component.scss' ]
})
export class FileManagerComponent implements OnInit, OnDestroy {

  @Input() image_path: string;

  // Lista de arquivos exibida na tela
  files: StoredFile[] = [];
  filesSubscription: Subscription | undefined;

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'image', 'copy', 'delete' ];

  // Variáveis para upload
  selectedFile: File | null = null;
  uploadTask: AngularFireUploadTask | undefined;
  uploadProgress: Observable<number | undefined> | undefined;
  downloadURL: string | null = null;
  isUploading = false;
  uploadError: string | null = null;


  constructor (
    private _fileManagerService: FileManagerService,
    private _dialog: MatDialog,
    private _clipboard: Clipboard
  ) {
    //this._fileManagerService.storage_path ='site_pub';
  }

  ngOnInit (): void {
    //console.log('image_path: ' + this.image_path) //
    this._fileManagerService.storage_path = this.image_path;
    this.loadFiles();
  }

  ngOnDestroy (): void {
    if (this.filesSubscription) {
      this.filesSubscription.unsubscribe();
    }
  }

  /**
   * Carrega a lista de arquivos do Firebase Storage.
   */
  loadFiles (): void {
    if (this.filesSubscription) {
      this.filesSubscription.unsubscribe();
    }
    this.filesSubscription = this._fileManagerService.listFiles().subscribe({
      next: (data) => {
        this.files = data;
        this.dataSource = new MatTableDataSource(this.files);
      },
      error: (err) => {
        console.error('Erro ao listar arquivos:', err);
        // Tratar erro de listagem (exibir mensagem ao usuário)
      }
    });
  }

  /**
   * Manipula a seleção de arquivo pelo input.
   * @param event Evento de mudança do input de arquivo.
   */
  onFileSelected (event: any): void {
    const file: File = event.target.files[ 0 ];
    if (file) {
      this.selectedFile = file;
    }
  }

  /**
   * Inicia o processo de upload do arquivo selecionado.
   */
  startUpload (): void {
    if (!this.selectedFile) {
      alert('Selecione um arquivo primeiro.');
      return;
    }

    this.isUploading = true;
    this.uploadError = null;
    this.downloadURL = null;

    const {task, downloadURL$} = this._fileManagerService.uploadFile(this.selectedFile);
    this.uploadTask = task;

    // Acompanhar o progresso
    this.uploadProgress = this.uploadTask.percentageChanges();

    // Obter o URL de download e finalizar
    downloadURL$.pipe(
      finalize(() => {
        this.isUploading = false;
        this.selectedFile = null;
        this.uploadTask = undefined;
        this.loadFiles(); // Recarrega a lista para incluir o novo arquivo
      })
    ).subscribe({
      next: (url) => {
        if (url) {
          this.downloadURL = url;
          console.log('Upload concluído. URL:', url);
        }
      },
      error: (err) => {
        this.uploadError = 'Erro no upload: ' + (err.message || 'Desconhecido');
        console.error('Erro no upload:', err);
      }
    });
  }

  openDelete (element) {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>Excluir este arquivo?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        console.log(JSON.stringify(element));
        this.deleteFile(element)
      }
    })

  }

  /**
   * Apaga um arquivo do Firebase Storage.
   * @param file Arquivo (StoredFile) a ser apagado.
   */
  deleteFile (file: StoredFile): void {
    //if (confirm(`Tem certeza que deseja apagar o arquivo: ${ file.name }?`)) {
    this._fileManagerService.deleteFile(file.fullPath)
      .then(() => {
        console.log('Arquivo apagado com sucesso:', file.name);
        this.loadFiles(); // Recarrega a lista após a exclusão
      })
      .catch(err => {
        console.error('Erro ao apagar arquivo:', err);
        alert('Erro ao apagar arquivo. Verifique as permissões.');
      });
    //}
  }

  /**
   * Formata o tamanho do arquivo para uma leitura amigável.
   * @param bytes Tamanho em bytes.
   */
  formatBytes (bytes: number | undefined): string {
    if (bytes === undefined) return 'N/A';
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = [ 'Bytes', 'KB', 'MB', 'GB', 'TB' ];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[ i ];
  }

  copyToClipboard (element: any): void {
    const data = element;
    const sucesso = this._clipboard.copy(data.name);

    if (sucesso) {
      // console.log('Informação copiada com sucesso!');
      // **OPCIONAL:** Você pode adicionar aqui uma notificação visual (snackbar/tooltip)
    } else {
      console.error('Falha ao copiar a informação.');
    }
  }

  listFiles () {
    const data = this.dataSource.data;

    let list: string = "Arquivos: " + "\n\n";

    data.forEach((item) => {
      list += "nome: " + item.name + "\n" + "path: " + item.downloadURL + "\n\n";
    })

    //console.log(list) 
    this._clipboard.copy(list);
  }

  getFiles () {
    const data = this.dataSource.data;
    let list: string = "Arquivos: " + "\n\n";
    data.forEach((item) => {
      list += "nome: " + item.name + "\n" + "path: " + item.downloadURL + "\n\n";
    })
    return list
  }

}